import * as React from "react";
import { isNil } from "ramda";
import { styled } from "styled-components";

import { typeScale } from "lib/themeUtils";

import { Grid } from "../../elements/grid";

const StatusImg = styled.img`
  width: 21rem;
  margin-left: auto;
  display: block;
`;

const Heading = styled.h1`
  ${typeScale.xxl}
  font-weight: bold;
  margin: 0 0 1rem 0;
`;

const Actions = styled.div`
  margin-top: 2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: flex-end;
`;

export const StatusView: React.FC<
  React.PropsWithChildren<{ heading?: string; actions?: React.ReactNode; imgSrc?: string }>
> = ({ heading, actions, imgSrc, children }) => {
  return (
    <Grid $cols={Grid.cols.EQUAL}>
      <div>
        {!isNil(heading) && <Heading>{heading}</Heading>}
        {children}
        {!isNil(actions) && <Actions>{actions}</Actions>}
      </div>
      <div>{!isNil(imgSrc) && <StatusImg src={imgSrc} />}</div>
    </Grid>
  );
};
